import { useCallback, useEffect } from 'react';
import { Metrics } from '../../utils/metrics';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TrackRender from 'growth-payments-core/usage-tracker/TrackRender';
import { TrackedButton } from 'growth-payments-core/usage-tracker/components/Button';
import { events } from 'growth-payments-core/usage-tracker/events';
import CelebrationModal from './CelebrationModal';
import { EnrollmentFlowType } from '../../types';
import { useQueryStringState } from 'growth-payments-core/query-string/useQueryStringState';
import { getParentWindow } from 'growth-payments-core/query-string/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEST_IDS = {
  KYC_PRE_APPROVAL_SUCCESS_MODAL_VERIFY: 'kyc-pre-approval-success-modal-verify'
};
const PreApprovedApplicationSuccessModal = ({
  businessTypeDetails,
  onClose,
  shouldReloadOnEnrollmentComplete = true
}) => {
  const [__, setCurrentEnrollmentFlow] = useQueryStringState('paymentsEnrollment', EnrollmentFlowType.processorPicker);
  const handleClick = useCallback(() => {
    setCurrentEnrollmentFlow(null);
    if (shouldReloadOnEnrollmentComplete) {
      getParentWindow().location.reload();
    } else {
      onClose();
    }
  }, [setCurrentEnrollmentFlow, shouldReloadOnEnrollmentComplete, onClose]);
  const {
    businessType,
    businessStructure
  } = businessTypeDetails;
  useEffect(() => {
    Metrics.counter('stripe-success-modal-viewed', {
      businessType: businessType || '',
      businessStructure: businessStructure || ''
    }).increment();
  }, [businessStructure, businessType]);
  const renderCta = () => {
    return /*#__PURE__*/_jsx(TrackedButton, {
      event: events.paymentSettingsInteraction,
      trackingProperties: {
        action: 'gotoZeroStateButtonClicked',
        location: 'pre-approved-application-success-modal'
      },
      "data-test-id": TEST_IDS.KYC_PRE_APPROVAL_SUCCESS_MODAL_VERIFY,
      use: "secondary",
      onClick: handleClick,
      children: shouldReloadOnEnrollmentComplete ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "stripeSubmissionSuccessModal.preApproval.cta"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "stripeSubmissionSuccessModal.continue"
      })
    });
  };
  return /*#__PURE__*/_jsx(CelebrationModal, {
    title: "stripeSubmissionSuccessModal.preApproval.header",
    testID: "kyc-pre-approval-success-modal",
    bodyContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(TrackRender, {
        event: events.growthPaymentsPageView,
        properties: {
          screen: 'kyc-pre-approval-success-modal'
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "stripeSubmissionSuccessModal.preApproval.body"
      })]
    }),
    onClose: handleClick,
    CTA: renderCta()
  });
};
export default PreApprovedApplicationSuccessModal;